'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.focusTransferWidget = function (target) {
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.on('show', function () {
			widget.find('[data-mm-request-focus]').visibleOnly().focus();
		})
		.on('hide', function () {
			if (target && document.activeElement.closest('.hidden')) {
				target.focus();
			}
		});
	});

};
